(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.celestiarToast = (message) => {
    const toast = document.getElementById('Toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._timer);
    toast._timer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };
  function initMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!toggle ||!menu) return;
    const closeMenu = () => {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    };
    toggle.addEventListener('click', () => {
      const shouldOpen = menu.hidden;
      if (shouldOpen) {
        menu.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('menu-open');
        // ferme tous les paniers possibles
        document.querySelectorAll('cart-drawer, #cart-drawer,.cart-drawer, [id*="cart"], [class*="cart-drawer"]').forEach(el => el.style.display = 'none');
      } else {
        closeMenu();
      }
    });
    menu.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;
        e.preventDefault();
        closeMenu();
        window.location.href = href;
      });
    });
  }
  function initModals() {
    const openers = document.querySelectorAll('[data-modal-open]');
    const modals = document.querySelectorAll('.modal');
    const openModal = (id) => {
      const modal = document.getElementById(`modal-${id}`);
      if (!modal) return;
      modal.hidden = false;
      document.body.classList.add('modal-open');
      const close = modal.querySelector('[data-modal-close]');
      if (close) close.focus({ preventScroll: true });
    };
    const closeModals = () => {
      modals.forEach((modal) => { modal.hidden = true; });
      document.body.classList.remove('modal-open');
    };
    openers.forEach((button) => button.addEventListener('click', (event) => { event.preventDefault(); openModal(button.dataset.modalOpen); }));
    document.querySelectorAll('[data-modal-close]').forEach((button) => button.addEventListener('click', closeModals));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModals();
    });
    if (document.querySelector('#modal-contact .form-success')) openModal('contact');
    const hashId = window.location.hash.slice(1);
    if (['mentions', 'cgv', 'confidentialite', 'livraison'].includes(hashId)) openModal(hashId);
  }

  function initReveal() {
    const items = document.querySelectorAll('.reveal');
    if (!items.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
    items.forEach((item, index) => {
      item.style.transitionDelay = item.classList.contains('reveal-delay-3') || item.classList.contains('reveal-delay-4') || item.classList.contains('reveal-delay-5')
        ? item.style.transitionDelay
        : `${Math.min(index % 3, 2) * 80}ms`;
      observer.observe(item);
    });
  }

  function initStarfields() {
    document.querySelectorAll('[data-starfield]').forEach((canvas) => {
      const ctx = canvas.getContext('2d');
      const isMobile = window.matchMedia('(max-width: 760px)').matches;
      const baseDensity = Number(canvas.dataset.density || 80);
      const density = isMobile ? Math.round(baseDensity * 0.5) : baseDensity;
      const withMeteors = canvas.hasAttribute('data-shooting-stars') && !reducedMotion;
      const withNebula = canvas.hasAttribute('data-nebula');
      const withConstellations = canvas.hasAttribute('data-constellations');
      let width = 0;
      let height = 0;
      let stars = [];
      let meteors = [];
      let nextMeteor = 0;
      let animationFrame = null;
      let running = false;
      let scrollY = 0;
      let mouseX = 0.5;
      let mouseY = 0.5;

      /* 3 couches de profondeur : petites lointaines, moyennes, grandes proches */
      const makeStars = () => {
        const arr = [];
        for (let i = 0; i < density; i++) {
          const layer = i % 10 < 6 ? 0 : i % 10 < 9 ? 1 : 2; // 60% / 30% / 10%
          arr.push({
            x: Math.random() * width,
            y: Math.random() * height,
            r: layer === 0 ? Math.random() * 0.6 + 0.2 : layer === 1 ? Math.random() * 0.9 + 0.6 : Math.random() * 1.2 + 1.1,
            a: layer === 0 ? Math.random() * 0.35 + 0.12 : layer === 1 ? Math.random() * 0.4 + 0.3 : Math.random() * 0.35 + 0.55,
            s: Math.random() * 0.011 + 0.003,               // frequence de scintillement variee
            p: Math.random() * Math.PI * 2,                  // phase aleatoire
            s2: Math.random() * 0.005 + 0.001,               // 2e frequence : irregulier
            p2: Math.random() * Math.PI * 2,
            depth: layer === 0 ? 0.25 : layer === 1 ? 0.6 : 1,
            gold: Math.random() < 0.16,
            halo: layer === 2 && Math.random() < 0.35,       // quelques etoiles brillantes a halo dore
          });
        }
        return arr;
      };

      const resize = () => {
        const rect = canvas.getBoundingClientRect();
        const ratio = Math.min(window.devicePixelRatio || 1, isMobile ? 1.5 : 2);
        width = Math.max(1, Math.floor(rect.width));
        height = Math.max(1, Math.floor(rect.height));
        canvas.width = width * ratio;
        canvas.height = height * ratio;
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        stars = makeStars();
      };

      const spawnMeteor = (time) => {
        if (meteors.length >= 2) { nextMeteor = time + 2000; return; } // max 1-2 a l'ecran
        const angle = Math.PI * (0.68 + Math.random() * 0.22); // diagonale, direction variee
        const speed = 7 + Math.random() * 8;                   // vitesse variee
        meteors.push({
          x: width * (0.25 + Math.random() * 0.7),
          y: height * Math.random() * 0.4,
          vx: Math.cos(angle) * speed,
          vy: -Math.sin(angle) * speed,
          born: time,
          life: 800 + Math.random() * 700,
          len: 70 + Math.random() * 110,                       // longueur variee
        });
        nextMeteor = time + 10000 + Math.random() * 5000;      // toutes les 10 a 15 s
      };

      const draw = (time = 0) => {
        ctx.clearRect(0, 0, width, height);

        /* Nebuleuse tres discrete : 2 nappes radiales bleu/violet sombre */
        if (withNebula) {
          const px = (mouseX - 0.5) * 8;
          const py = (mouseY - 0.5) * 8;
          let neb = ctx.createRadialGradient(width * 0.72 + px, height * 0.28 + py, 0, width * 0.72 + px, height * 0.28 + py, Math.max(width, height) * 0.55);
          neb.addColorStop(0, 'rgba(88, 72, 148, 0.07)');
          neb.addColorStop(1, 'rgba(88, 72, 148, 0)');
          ctx.fillStyle = neb;
          ctx.fillRect(0, 0, width, height);
          neb = ctx.createRadialGradient(width * 0.18 - px, height * 0.7 - py, 0, width * 0.18 - px, height * 0.7 - py, Math.max(width, height) * 0.45);
          neb.addColorStop(0, 'rgba(52, 74, 148, 0.06)');
          neb.addColorStop(1, 'rgba(52, 74, 148, 0)');
          ctx.fillStyle = neb;
          ctx.fillRect(0, 0, width, height);
        }

        /* Parallaxe douce : scroll + souris, tres subtile */
        const offY = reducedMotion ? 0 : scrollY * 0.03;
        const offX = reducedMotion ? 0 : (mouseX - 0.5) * 6;

        /* Fines lignes de constellation dorees, decoratives */
        if (withConstellations) {
          ctx.strokeStyle = 'rgba(201, 168, 92, 0.14)';
          ctx.lineWidth = 0.7;
          const bright = stars.filter((s) => s.halo);
          for (let i = 0; i + 1 < bright.length; i += 3) {
            const a = bright[i], b = bright[i + 1];
            if (!b) break;
            const dist = Math.hypot(a.x - b.x, a.y - b.y);
            if (dist > 90 && dist < Math.min(width, height) * 0.45) {
              ctx.beginPath();
              ctx.moveTo(a.x + offX * a.depth, a.y + offY * a.depth);
              ctx.lineTo(b.x + offX * b.depth, b.y + offY * b.depth);
              ctx.stroke();
            }
          }
        }

        stars.forEach((star) => {
          /* Scintillement irregulier : 2 sinusoides desynchronisees */
          const tw = reducedMotion ? 1 : 0.55 + Math.sin(time * star.s + star.p) * 0.28 + Math.sin(time * star.s2 + star.p2) * 0.17;
          const alpha = Math.max(0.06, star.a * tw);
          const x = star.x + offX * star.depth;
          let y = star.y + offY * star.depth;
          y = ((y % height) + height) % height;
          if (star.halo) {
            const halo = ctx.createRadialGradient(x, y, 0, x, y, star.r * 6);
            halo.addColorStop(0, `rgba(212, 175, 55, ${0.28 * alpha})`);
            halo.addColorStop(1, 'rgba(212, 175, 55, 0)');
            ctx.fillStyle = halo;
            ctx.beginPath();
            ctx.arc(x, y, star.r * 6, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.beginPath();
          ctx.arc(x, y, star.r, 0, Math.PI * 2);
          ctx.fillStyle = star.gold
            ? `rgba(232, 213, 163, ${alpha})`
            : `rgba(226, 232, 255, ${alpha})`;
          ctx.fill();
        });

        if (withMeteors) {
          if (time >= nextMeteor) spawnMeteor(time);
          meteors = meteors.filter((m) => time - m.born < m.life);
          meteors.forEach((m) => {
            const age = (time - m.born) / m.life;
            const fade = age < 0.18 ? age / 0.18 : 1 - (age - 0.18) / 0.82;
            const x = m.x + m.vx * (time - m.born) / 16.7;
            const y = m.y + m.vy * (time - m.born) / 16.7;
            const mag = Math.hypot(m.vx, m.vy);
            const tx = x - (m.vx / mag) * m.len;
            const ty = y - (m.vy / mag) * m.len;
            const trail = ctx.createLinearGradient(x, y, tx, ty);
            trail.addColorStop(0, `rgba(255, 250, 235, ${0.9 * fade})`);
            trail.addColorStop(0.3, `rgba(212, 175, 55, ${0.5 * fade})`);
            trail.addColorStop(1, 'rgba(212, 175, 55, 0)');
            ctx.strokeStyle = trail;
            ctx.lineWidth = 1.6;
            ctx.lineCap = 'round';
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(tx, ty);
            ctx.stroke();
            /* courte lueur a la tete */
            const glow = ctx.createRadialGradient(x, y, 0, x, y, 7);
            glow.addColorStop(0, `rgba(255, 248, 226, ${0.8 * fade})`);
            glow.addColorStop(1, 'rgba(255, 248, 226, 0)');
            ctx.fillStyle = glow;
            ctx.beginPath();
            ctx.arc(x, y, 7, 0, Math.PI * 2);
            ctx.fill();
            ctx.beginPath();
            ctx.arc(x, y, 1.7, 0, Math.PI * 2);
            ctx.fillStyle = `rgba(255, 248, 226, ${0.95 * fade})`;
            ctx.fill();
          });
        }

        if (running && !reducedMotion) animationFrame = window.requestAnimationFrame(draw);
      };

      const start = () => {
        if (running || reducedMotion) return;
        running = true;
        animationFrame = window.requestAnimationFrame(draw);
      };
      const stop = () => {
        running = false;
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        animationFrame = null;
      };

      resize();
      if (reducedMotion) draw(); else start();
      if (canvas.hasAttribute('data-meteor-burst') && withMeteors) {
        /* Bouquet d'étoiles filantes à l'ouverture (effet wow) */
        spawnMeteor(performance.now());
        window.setTimeout(spawnMeteor, 350, performance.now());
        window.setTimeout(spawnMeteor, 800, performance.now());
      }

      /* Pause quand l'onglet n'est pas visible */
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else if (!reducedMotion) start();
      });

      if (!reducedMotion) {
        window.addEventListener('scroll', () => { scrollY = window.scrollY; }, { passive: true });
        window.addEventListener('pointermove', (e) => {
          mouseX = e.clientX / Math.max(1, window.innerWidth);
          mouseY = e.clientY / Math.max(1, window.innerHeight);
        }, { passive: true });
      }

      window.addEventListener('resize', () => {
        const wasRunning = running;
        stop();
        resize();
        if (reducedMotion) draw(); else if (wasRunning || !document.hidden) start();
      }, { passive: true });
    });
  }

  /* ---------- Etincelles dorees au survol du CTA hero ---------- */
  function initCtaSparkles() {
    if (reducedMotion) return;
    document.querySelectorAll('.hero__actions .btn--gold, .final-cta .btn--gold').forEach((btn) => {
      btn.classList.add('has-sparkles');
      btn.addEventListener('pointerenter', () => {
        for (let i = 0; i < 7; i++) {
          const sp = document.createElement('span');
          sp.className = 'cta-sparkle';
          sp.style.left = `${10 + Math.random() * 80}%`;
          sp.style.top = `${15 + Math.random() * 70}%`;
          sp.style.setProperty('--dx', `${(Math.random() - 0.5) * 46}px`);
          sp.style.setProperty('--dy', `${-12 - Math.random() * 30}px`);
          sp.style.animationDelay = `${Math.random() * 120}ms`;
          btn.appendChild(sp);
          window.setTimeout(() => sp.remove(), 900);
        }
      });
    });
  }

  /* ---------- Zoom affiche : loupe sur les détails dorés ---------- */
  function initPosterZoom() {
    const frame = document.querySelector('.poster-frame');
    if (!frame || !window.matchMedia('(pointer: fine)').matches) return;
    frame.classList.add('has-zoom');
    frame.addEventListener('mousemove', (e) => {
      const r = frame.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      frame.style.setProperty('--zoom-x', `${x}%`);
      frame.style.setProperty('--zoom-y', `${y}%`);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    initModals();
    initReveal();
    initStarfields();
    initCtaSparkles();
    initPosterZoom();
    /* Retour du formulaire contact Shopify : rouvrir la modale avec le message de succès */
    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      const contactModal = document.getElementById('modal-contact');
      if (contactModal) contactModal.hidden = false;
    }
  });
})();
